export default __webpack_public_path__ + "static/media/noImage.bdaacba1.jpg";